/**
 * @generated SignedSource<<61cd3a171f737993c94cf2db96df60ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "vendorId",
        "variableName": "accountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "stage": 1
      }
    }
  ],
  "concreteType": "VppRtsConnection",
  "kind": "LinkedField",
  "name": "vppRTsByVppId",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": "vppRTsByVppId(condition:{\"stage\":1})"
},
v4 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "accountId"
        },
        {
          "kind": "Literal",
          "name": "relationType",
          "value": 0
        }
      ],
      "kind": "ObjectValue",
      "name": "condition"
    }
  ],
  "concreteType": "AccountRelationTsConnection",
  "kind": "LinkedField",
  "name": "allAccountRelationTs",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorResellerFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VppTsConnection",
        "kind": "LinkedField",
        "name": "allVppTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorResellerFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VppTsConnection",
        "kind": "LinkedField",
        "name": "allVppTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "8542de47fdbeae13c80902a8a248e164",
    "id": null,
    "metadata": {},
    "name": "VendorResellerFetchQuery",
    "operationKind": "query",
    "text": "query VendorResellerFetchQuery(\n  $accountId: UUID!\n) {\n  allVppTs(condition: {vendorId: $accountId}) {\n    nodes {\n      vppRTsByVppId(condition: {stage: 1}) {\n        totalCount\n      }\n      nodeId\n    }\n  }\n  allAccountRelationTs(condition: {accountId: $accountId, relationType: 0}) {\n    totalCount\n  }\n}\n"
  }
};
})();

node.hash = "657bf65ab0ceb8fd742da8e796e4af93";

module.exports = node;
